var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMirajArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "197px",
    height: "188px",
    viewBox: "0 0 197 188",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "miraj-arrow@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "miraj-arrow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0, 0)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.9,28.1 L196.6,0 L176.3,31.1 C176.3,31.1 182,20.1 176.8,19.3 C171.7,18.1 152.8,26.3 149.9,28.1",
    id: "XMLID_14_",
    fill: "#F05E2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3,1.4 C37.6,-0.1 17.7,4 0,12.4 C16.6,5.5 32.8,5 51.9,5.3 C83.1,5.8 112,22.6 132.5,47.5 C132,48 130.1,50.5 125.5,60.2 C122.7,65.9 106.6,73.1 106.6,73.1 C106.6,73.1 93.1,80.3 89.2,84.2 C85.3,88.1 80.2,92.5 80,103.1 C80,103.1 80.2,104.3 80.9,103.8 C80.9,103.8 85.2,96.9 88.7,92.7 C92.2,88.6 95.6,86.4 97.4,85.2 C99.1,84 118.7,70.7 121.5,68.3 C124.4,66 130.2,61 131.1,59.9 C132.1,58.8 132.5,58.3 133.1,55.9 C133.5,54.1 135.5,53 136.4,52.6 C154.4,76.6 164.8,107 162.6,136.9 C161.2,156.3 157.1,171.9 148.1,187.7 C158.8,171.1 165.6,151.5 167.1,130.2 C172.1,63.8 123.3,6.1 58.3,1.4",
    id: "XMLID_15_",
    fill: "#263B80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.5,73 C128.5,73 122,77.1 120.7,78 C119.5,78.9 116.5,80.7 113.6,86.4 C110.7,92.2 107.8,97.7 107.3,98.8 C106.7,99.9 105.8,102.1 102.4,104.2 C99,106.3 93.7,108.4 91.1,113.9 C91.1,113.9 90.3,115.9 92,118.5 C92,118.5 92.7,119.4 93,117.9 C93.6,116 95.3,112.6 97.7,110.8 C97.7,110.8 101.9,107.7 105.9,106.5 C109.9,105.2 113.4,100.9 114.8,97.8 C116.3,94.7 119.7,84 120.9,82 C122.1,80.1 123.8,77.6 128.4,75.1 L128.5,73 Z",
    id: "XMLID_16_",
    fill: "#263B80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7,113 C80.7,113 91.7,116.9 90.3,129.2 C90.3,129.2 90,132.3 86.7,138.2 C83.3,144.3 80.2,150.1 79.2,153.3 C78.2,156.6 76.7,162.7 78.5,170.2 C78.5,170.2 78,170.4 77.1,169.1 C75.7,166.9 72.7,161.5 72.2,158.4 C71.7,155.4 70.9,151.1 76.1,141.2 C80.2,133.4 81.7,131.9 82.7,128.6 C83.8,125.3 84.2,121.3 80.7,113",
    id: "XMLID_17_",
    fill: "#263B80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3,99.9 C72,98.6 73.5,97.7 74,95 C73.1,93.2 64.8,78.2 63.3,75.8 C60.8,74.3 57.7,73.2 54.5,73.2 C45.3,73.2 37.9,80.7 37.9,89.9 C37.9,96.7 42,102.6 47.8,105.1 C47.6,106.8 47.4,108.9 47.3,110.5 C34.5,116.9 24.5,118.6 19.9,132.1 C19,134.7 13.9,141.2 16.6,145.2 C18.9,148.6 28.8,146 31.8,144.9 C43.2,140.6 51.6,131.9 55.5,119.9 L55.5,117.8 L55.2,117.8 C47.3,126 40,136.6 23.9,136.3 C16.5,129.1 39.8,113.9 48.5,113.5 C48.5,113.5 49.4,105.8 54.1,101.6 C57.2,98.8 60.6,100.4 62.5,102.3 L63.1,101.7 C60.6,93.2 50.9,92.6 48.9,100.6 C45,98.6 42.4,94.5 42.4,89.9 C42.4,83.2 47.8,77.8 54.5,77.8 C57.1,77.8 59.5,78.7 61.5,80.1 C61.1,81.3 60.8,81.9 60.2,83.4 C62.6,84.7 65.4,87 67.2,88 C66.8,89.1 66.4,90.3 66,91.4 C67,92.7 68.7,93.9 69.7,95.2 C69.6,98.3 67.4,99.4 65.1,100.2 L65.1,100.5 C67.7,100.8 70.2,101.2 72.7,101.5 L72.7,101.2 C71.8,100.9 71.4,100.7 70.7,100.4 C70.7,100.3 70.5,100.1 70.3,99.9",
    id: "XMLID_18_",
    fill: "#263B80"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMirajArrow);
export default __webpack_public_path__ + "static/media/miraj-arrow.c66f9bb5ce266823128c521b18b296d4.svg";
export { ForwardRef as ReactComponent };